import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingProgressProps {
  loaded: number;
  total: number;
  isLoadingMore: boolean;
}

export const LoadingProgress: React.FC<LoadingProgressProps> = ({
  loaded,
  total,
  isLoadingMore
}) => {
  if (!isLoadingMore && loaded === 0) return null;

  const percentage = total > 0 ? Math.round((loaded / total) * 100) : 0;

  return (
    <div className="flex items-center gap-3 bg-neutral-800 px-4 py-3 rounded-lg border border-neutral-700">
      {isLoadingMore && (
        <Loader2 className="w-4 h-4 text-blue-500 animate-spin flex-shrink-0" />
      )}
      <div className="flex-1">
        <div className="flex items-center justify-between mb-1">
          <span className="text-sm text-neutral-300">
            {isLoadingMore ? 'Carregando oportunidades...' : 'Carregamento completo'}
          </span>
          <span className="text-sm font-medium text-neutral-200">
            {loaded} {total > 0 && `de ${total}`}
          </span>
        </div>
        {total > 0 && (
          <div className="w-full bg-neutral-700 rounded-full h-2 overflow-hidden">
            <div
              className="h-full bg-blue-500 transition-all duration-300 rounded-full"
              style={{ width: `${percentage}%` }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
